import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// DASHBOARD: GENERAL
export const GeneralAnalyticsPage = Loadable(
  lazy(() => import('../pages/dashboard/GeneralAnalyticsPage'))
);

// DASHBOARD: USER
export const UserListPage = Loadable(lazy(() => import('../pages/dashboard/UserListPage')));
export const UserCreatePage = Loadable(lazy(() => import('../pages/dashboard/UserCreatePage')));
export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));

// DASHBOARD: Task
// export const TaskProfilePage = Loadable(lazy(() => import('../pages/dashboard/TaskProfilePage')));
// export const TaskCardsPage = Loadable(lazy(() => import('../pages/dashboard/TaskCardsPage')));
export const TaskListPage = Loadable(lazy(() => import('../pages/dashboard/TaskListPage')));
export const AllClaimsPage = Loadable(lazy(() => import('../pages/dashboard/AllClaims')));
// export const TaskAccountPage = Loadable(lazy(() => import('../pages/dashboard/TaskAccountPage')));
export const TaskCreatePage = Loadable(lazy(() => import('../pages/dashboard/TaskCreatePage')));
export const TaskCreateNewPage = Loadable(lazy(() => import('../pages/dashboard/TaskCreateNewPage')));

// export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));
export const TaskDetailsPage = Loadable(lazy(() => import('../pages/dashboard/TaskDetailsPage')));

// DASHBOARD: APP
export const GPSPage = Loadable(lazy(() => import('../pages/dashboard/GPSPage')));

// REPORTS
export const AnimalsReport = Loadable(lazy(() => import('../pages/dashboard/AnimalReportPage'))); 

// TEST RENDER PAGE BY ROLE
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);

// BLANK PAGE
export const BlankPage = Loadable(lazy(() => import('../pages/dashboard/BlankPage')));

// MAIN
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));

